import { render } from "./Login_Loader.vue?vue&type=template&id=f905a8e6&scoped=true"
const script = {}

import "./Login_Loader.vue?vue&type=style&index=0&id=f905a8e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f905a8e6"]])

export default __exports__